import { Controller } from "stimulus";
import { flashError, flashSuccess } from "../legacy/admin/flash";
import initSharedOptionsSelects from "../sharedOptionsSelect";

export default class extends Controller {
  static targets = ["check", "submit"];
  static values = { resource: String, id: Number };

  connect() {
    this.triggerSelect2();

    // catch the select2 jQuery event and dispatch a native event
    // so we can treat regular <select> and select2 dropdowns the same
    $(this.element).on("select2:select", (event) => {
      const changeEvent = new Event("change", { bubbles: true });
      event.target.dispatchEvent(changeEvent);
    });
  }

  check(event) {
    if (event.target.type !== "checkbox") {
      this.checkTarget.click();
    }
  }

  submitForm() {
    this.submitTarget.click();
  }

  showChanges(changes) {
    for (const [attribute, change] of Object.entries(changes)) {
      flashSuccess(`Updated ${attribute} to ${change[1]}`);
    }
  }

  showErrors(event) {
    const errors = event.detail[0].errors;

    if (errors) {
      for (const [attribute, message] of Object.entries(errors)) {
        flashError(`Error: ${attribute} ${message}`);
      }
      this.element.classList.add("error");
    } else {
      flashError(event.detail[1]);
    }
  }

  toggleRow() {
    this.element.classList.toggle("selected", this.checkTarget.checked);
  }

  // for compatibility
  triggerSelect2() {
    $(
      `#${this.element.id} select:not(.default-select, .search-select-input, .shared-options-select)`
    ).select2();
    initSharedOptionsSelects(document.getElementById(this.element.id) || this.element);
  }

  updateRow(event) {
    // this.element will no longer exist after update or delete
    const parent = this.element.parentElement;
    const response = event.detail[0];

    switch (response.action) {
      case "update":
        this.element.outerHTML = response.html;
        this.triggerSelect2();
        break;
      case "destroy":
        this.element.remove();
        break;
      default:
        break;
    }

    if (response.changes) {
      this.showChanges(response.changes);
    }

    flashSuccess(response.message);

    const updateEvent = new CustomEvent("cortana:record_updated", { bubbles: true });
    parent.dispatchEvent(updateEvent);
  }
}
